import BaseService from "../base.service";

const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

class LiveStreamService extends BaseService {
    getLinkLiveStream(gameId: any) {
        return this.get(`${VUE_APP_API_URL}/api/stream?game_id=${gameId}`).then(({ data }) => data)
    }
}
export default new LiveStreamService()